import React from 'react';
import { Field, renderFields } from '../Form';
import { useFormikContext } from 'formik';

export default function FieldGroup({ fields, inputClassName, noMargin = true }) {
  const { values, setFieldValue } = useFormikContext();

  if (!fields) return null;

  return (
    <div className="flex flex-col gap-1">
      {renderFields({ fields, values, setFieldValue }).map(field => (
        <Field
          key={field.name}
          field={{
            ...field,
            visible: field.visible === undefined ? true : field.visible,
            noMargin,
          }}
          values={values}
          inputClassName={inputClassName}
        />
      ))}
    </div>
  );
}
